import { ITimestampResponse } from '@/types/common';
import { IUser } from '../user';

export enum InquiryStatus {
  NOT_ANSWER,
  ANSWERED,
}

export interface IInquiry extends ITimestampResponse {
  id: number;

  name: string;

  email: string;

  isRegistered: boolean;

  content: string;

  deviceName: string;

  osVersion: string;

  appVersion: string;

  status: InquiryStatus;

  createdBy: IUser;
}

export interface IGetListInquiryResponse extends IInquiry {}

export interface IGetDetailInquiryResponse extends IInquiry {}
